import PropTypes from "prop-types";
import React from "react";
import { SelectionControlGroup } from "react-md";

const SelectionGroup = props => {
  const { input, containerClassName, meta, ...rest } = props;
  delete rest.meta;
  delete rest.input;
  delete rest.containerClassName;
  delete rest.error;
  delete rest.errorText;

  const inError = meta.touched && meta.invalid;
  return (
    <div>
      <SelectionControlGroup
        className={containerClassName}
        type="radio"
        {...rest}
        {...input}
      />
      <div className="validation-error" style={{marginLeft: "7%"}}>
          {
            inError &&
            meta.error
          }
      </div>      
    </div>
    );
};

SelectionGroup.propTypes = {
  input: PropTypes.object.isRequired,
  containerClassName: PropTypes.string,
  meta: PropTypes.object.isRequired,
};
export default SelectionGroup;